module.exports = __webpack_public_path__ + "static/media/sell_send_money_1.c6046f37.jpg";